/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFreelancerNoteRequest
 */
export interface CreateFreelancerNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFreelancerNoteRequest
     */
    content: string;
}

/**
 * Check if a given object implements the CreateFreelancerNoteRequest interface.
 */
export function instanceOfCreateFreelancerNoteRequest(value: object): value is CreateFreelancerNoteRequest {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CreateFreelancerNoteRequestFromJSON(json: any): CreateFreelancerNoteRequest {
    return CreateFreelancerNoteRequestFromJSONTyped(json, false);
}

export function CreateFreelancerNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFreelancerNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function CreateFreelancerNoteRequestToJSON(value?: CreateFreelancerNoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
    };
}

